<!--
作業・生産記録画面
URL：/product
表示条件：ログイン済みであること
-->

<template>
  <div>
    <alert :errors="errors" css_class="ma-1"></alert>
    <list-table class="mt-12" :itemList="itemList"></list-table>
  </div>
</template>

<script>
import ListTable from "../../components/product-records/list-table.vue";
import DateWrapper from "../../logic/common/date-wrapper";
import Alert from "../../components/common/alert.vue";
import Api from "@/logic/api/api.js";
import Roles from "@/logic/common/roles";
export default {
  components: {
    "list-table": ListTable,
    alert: Alert,
  },

  computed: {
    itemList() {
      return this.$store.getters.haccpUserList;
    },
  },

  data() {
    this.$nextTick(() => {
      // ユーザー一覧を取得する
      this.$store.commit("setWaiting", true);
      Api.call("/admin/user", {
        purpose: "VIEW_HACCP",
      })
        .then((result) => {
          this.$store.commit("setWaiting", false);
          this.$store.commit(
            "setHaccpUserList",
            result.users.map((user) => {
              return {
                uid: user.uid,
                userName: user.display_name,
                group: user.permissions
                  .filter((group) => group.type == "join")
                  .map((group) => {
                    return {
                      name: group.owner.display_name,
                      id: group.owner.group_id,
                      color: Roles.roleToRoleColor(group.role),
                      detail: Roles.roleToRoleDescription(
                        group.owner.display_name,
                        group.role,
                        group.area
                      ),
                    };
                  }),
                lastUpdate: new DateWrapper(
                  user.update_haccp_date
                ).format.build((d) => {
                  // 2000年よりも最近に更新があったのなら日時を返す
                  if (d.date.y >= 2000) {
                    return `${d.date.y}/${d.date.m02}/${d.date.d02}`;
                  }
                  // 2000年以前が最終更新日時であればハイフンを返す
                  return "-";
                }),
                flagProducer: user.flag_producer,
                csvPermission: user.csv_permission,
                seaArea: user.harvest_sea_area,
                deviceId: user.device_id,
              };
            })
          );
        })
        .catch((result) => {
          this.$store.commit("setWaiting", false);
          Api.resolve(result);
        });
    });
    return {
      errors: [],
    };
  },
};
</script>

<style></style>
